<template>
  <div>
    <ca-heading text="Quadro de horários" size="medium"></ca-heading>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>

    <ca-table class="ca-u-min-margin-top">
      <ca-tr slot="header">
        <ca-th>Descrição</ca-th>
        <ca-th>Código</ca-th>
        <ca-th>Hr entrada</ca-th>
        <ca-th>Hr saída</ca-th>
        <ca-th>Duração</ca-th>
        <ca-th>Intervalo</ca-th>
      </ca-tr>
      <ca-tr v-for="(shift, index) in shiftBoard.associatedWorkshifts" :key="index">
        <ca-td>
          {{ codeDays[shift.weekDay.name] }}
        </ca-td>
        <ca-td>
          {{ shift.workshift.code }}
        </ca-td>
        <ca-td>
          {{ shift.workshift.checkInTime }}
        </ca-td>
        <ca-td>
          {{ shift.workshift.checkOutTime }}
        </ca-td>
        <ca-td>
          {{ `${shift.workshift.workingHours} horas` }}
        </ca-td>
        <ca-td>
          {{ getIntervalDuration(shift.workshift) }}
        </ca-td>
      </ca-tr>
      <ca-tr>
        <ca-td>Tipo de Jornada</ca-td>
        <ca-td colspan="5">
          {{ shiftBoard.journeyType.description }}
        </ca-td>
      </ca-tr>
      <ca-tr>
        <ca-td>Carga semanal em horas</ca-td>
        <ca-td colspan="5">
          {{ shiftBoard.weeklyHours }}
        </ca-td>
      </ca-tr>
    </ca-table>
  </div>
</template>

<script>
import { CODE_DAYS } from '../../workerConstants';
import { getIntervalDuration } from '../../workersService';

export default {
  name: 'WorkerShiftInfo',
  props: {
    shiftBoard: Object,
    jobInfo: Object,
    worker: Object,
  },
  data() {
    return {
      codeDays: CODE_DAYS,
    };
  },
  methods: {
    getIntervalDuration,
    goBack() {
      this.$router.back();
    },
    onEdit() {
      this.$router.push({
        name: 'WorkerShiftInfoPage',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
